export const userProfileMessages = {
  en: {
    userForm: {
      title: 'Profile',
      username: 'Username',
      timezone: 'Timezone',
      save: 'Update profile',
      updated: 'User profile updated',
    },
    passwordForm: {
      title: 'Change Password',
      passwordChangeInfo:
        'Changing your password will log you out of all existing sessions.',
      oldPassword: 'Old password',
      newPassword: 'New password',
      retypePassword: 'Retype password',
      save: 'Update password',
      updated: 'Password updated, you have to login again',
    },
    validations: {
      required: 'Required field',
      noMatch: 'Passwords do not match',
      minLength: 'Password must have at least 8 characters',
      maxLength: 'Password must have at most 100 characters',
    },
  },
};
